export function CheckScroll(setIsScrolled, numeric = false) {
    if(numeric) {
        setIsScrolled(window.scrollY);
        return;
    }

    if (window.scrollY > 0) {
        setIsScrolled(true);
    } else {
        setIsScrolled(false);
    }
}